import React from "react";
import "../css/NPAReport.css";
import comingSoonIcon from "../assets/19.png"; // Use a relevant illustration

const NPAReport = () => {
  return (
    <div className="NPAReport-wrapper">
      <div className="NPAReport-leftPanel">
        <h1 className="NPAReport-title">NPA Report</h1>
        <p className="NPAReport-message">
          🚧 This section is under active development.
        </p>
        <p className="NPAReport-message">
          Soon you will be able to track Non-Performing Assets (NPA), view overdue loans, 
          penalties, and generate detailed reports for better financial control.
        </p>
        <p className="NPAReport-message">
          Our team is working hard to deliver a powerful and interactive NPA reporting tool.
        </p>

        <div className="NPAReport-progressBars">
          <div className="progressBar bar1"></div>
          <div className="progressBar bar2"></div>
          <div className="progressBar bar3"></div>
          <div className="progressBar bar4"></div>
          <div className="progressBar bar5"></div>
        </div>
      </div>

      <div className="NPAReport-rightPanel">
        <img
          src={comingSoonIcon}
          alt="Coming Soon Graph"
          className="NPAReport-image"
        />
      </div>
    </div>
  );
};

export default NPAReport;
